import React, {useState} from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import {Input} from '@stubhub/bamboo';
import SearchInputRightAction from './SearchInputRightAction';
import SearchInputIcon from './SearchInputIcon';
import {useIntl} from 'react-intl';
import messages from './messages';
import './SearchFilterInput.scss';

const SearchFilterInput = ({onChange, isMobile}) => {
  const [inputVal, setInputVal] = useState('');

  const intl = useIntl();

  const handleClearInput = () => {
    setInputVal('');
    onChange && onChange('');
  };

  const handleOnChange = (e) => {
    const {value} = e.target;
    onChange && onChange(value);
    setInputVal(value);
  };

  return (
    <div className={cx({SearchFilterInput: true, Mobile: isMobile})}>
      <Input
        id="searchInput__attributes"
        value={inputVal}
        className="SearchFilter__Input"
        labelText={intl.formatMessage(messages.searchInput)}
        onChange={handleOnChange}
        type="search"
        leftElement={<SearchInputIcon />}
        rightElement={
          inputVal && (
            <SearchInputRightAction handleActionClick={handleClearInput} />
          )
        }
      />
    </div>
  );
};

SearchFilterInput.defaultProps = {
  isMobile: false
};

SearchFilterInput.propTypes = {
  isMobile: PropTypes.bool,
  onChange: PropTypes.func
};

export default SearchFilterInput;
